import { MarketplaceCategoriesModel } from '../../../../models/dashboard/marketplace/marketplaceCategoryModel';
import { adminHttpClient } from "../../../../commons/adminHttpClinet";


const getCategories = (): Promise<Array<MarketplaceCategoriesModel>> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplace/get-categories`)
}
export default getCategories;